import React from 'react';
import { MDBContainer, MDBDataTable, MDBRow, MDBCol, MDBBtn, MDBSelect, MDBIcon, MDBCard, MDBCardBody } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';
import Formatter from '../Utilities/Formatter';
import DashboardLineGraph from './ComponentFragments/DashboardLineGraph';

export default class Getup extends React.Component {

    constructor(props) {
        super(props);
        this.props.loaderOn();
        this.state = {
            teamData: [],
            yearData: [],
            segmentData: [],
            unitData: [],
            currSegment: 0,
            selectedYear: 0,
            selectedSegment: 0,
            selectedUnit: 0,
            tableHidden: true,
            m1Earnings: 0,
            m2Earnings: 0,
            m3Earnings: 0,
            totalGetUpEarnings: 0,
            earnM1: 0,
            earnM2: 0,
            earnM3: 0,
            unitStandard: 0,
            personalSalesStandard: 0,
            unitSales: 0,
            personalSales: 0
        }
        this.formatter = new Formatter();
        this.handleYearSelectChange = this.handleYearSelectChange.bind(this);
        this.handleUnitSelectChange = this.handleUnitSelectChange.bind(this);
        this.handleSegmentSelectChange = this.handleSegmentSelectChange.bind(this);
        this.getGetUpData = this.getGetUpData.bind(this);
    }

    async loadSegmentsForYear(year) {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/common/getsegmentsforyear?yearId=' + year, 200);
        let qualDataResult = await dl.Get('/demonstrator/getGetUpQualificationData?segmentId=' + this.state.currSegment, 200);
        let segData = [];
        result.data.forEach((segment) => segData.push(
            { checked: segment.periodId == this.state.currSegment ? true : false, value: segment.periodId, text: segment.description }
        ));
        let earn1 = 0;
        let earn2 = 0;
        let earn3 = 0;
        qualDataResult.data.forEach((qual) => {
            switch (qual.mdResultCode) {
                case "881":
                    earn1 = qual.amount;
                    break;
                case "882":
                    earn2 = qual.amount;
                    break;
                case "883":
                    earn3 = qual.amount;
                    break;
            }
        });

        this.setState({
            segmentData: segData,
            selectedSegment: segData[0].value,
            earnM1: earn1,
            earnM2: earn2,
            earnM3: earn3

        })

        this.props.loaderOff();
    }

    handleUnitSelectChange(selected) {
        this.setState({
            selectedUnit: selected[0]
        });
    }

    handleYearSelectChange(selected) {
        this.setState({
            selectedYear: selected[0]
        });
        this.loadSegmentsForYear(selected[0])
    }

    handleSegmentSelectChange(selected) {
        this.setState({
            selectedSegment: selected[0]
        });
    }



    async componentWillMount() {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/common/getyears', 200);
        let currSeg = await dl.Get('/common/getCurrSegment', 200);

        let yearsData = [];
        let unitsData = [];

        let TMAUser = JSON.parse(localStorage.getItem("TMAUser"));

        if (TMAUser.data.statusCode1 == 'T') {
            let unitResponse = await dl.Get('/teamleader/getunitslist', 200)
            unitResponse.data.data.forEach((unit) => unitsData.push({ checked: false, value: unit.unitId, text: unit.unitName }));
            unitsData[0].checked = true;
        }

        result.data[0].forEach((year) => yearsData.push({ checked: false, value: year.value, text: year.label }));
        yearsData[0].checked = true;

        this.setState({
            yearData: yearsData,
            unitData: unitsData,
            selectedYear: yearsData[0].value,
            currSegment: currSeg.data
        })
        this.props.loaderOff();
    }

    async getGetUpData() {

        this.props.loaderOn();
        let TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        let unitId = TMAUser.data.statusCode1 == "T" ? this.state.selectedUnit : TMAUser.data.unitId
        var dl = new DataLayer();
        let getUpData = await dl.Get('/demonstrator/getGetUpData?segmentId=' + this.state.selectedSegment + '&unitId=' + unitId, 200);
        let qualDataResult = await dl.Get('/demonstrator/getGetUpQualificationData?segmentId=' + this.state.selectedSegment, 200);
        let personalLevels = await dl.Get('/demonstrator/getGetUpPersonalQualificationData?segmentId=' + this.state.selectedSegment + '&unitId=' + unitId, 200);
        //await dl.Get('/teamleader/GetTeamPerformance?fromWeek=' + this.state.selectedFromWeek + '&toWeek=' + this.state.selectedToWeek, 200).then((response) => {
        let demRecs = [];
        let rec;
        let month1Earnings = 0;
        let month2Earnings = 0;
        let month3Earnings = 0;
        let totalEarnings = 0;
        let segmentSalesToApply = 0;
        let month1QualLvl = 0;
        let month2QualLvl = 0;
        let month3QualLvl = 0;

        let month1Amount = 0;
        let month2Amount = 0;
        let month3Amount = 0;
        qualDataResult.data.forEach((qual) => {
            switch (qual.mdResultCode) {
                case "881":
                    month1Amount = qual.amount;
                    month1QualLvl = qual.qualValue
                    break;
                case "882":
                    month2Amount = qual.amount;
                    month2QualLvl = qual.qualValue
                    break;
                case "883":
                    month3Amount = qual.amount;
                    month3QualLvl = qual.qualValue
                    break;

            }
        });
        getUpData.data.map((dem) => {
            segmentSalesToApply = dem.segmentSalesToApply;
            if (segmentSalesToApply > 1) {
                //month1Earnings += (dem.month1Sales >= month1QualLvl && segmentSalesToApply == 1) ? month1Amount : 0;
                month2Earnings += (dem.month2Sales >= month2QualLvl && segmentSalesToApply == 2) ? month2Amount : 0;
                month3Earnings += (dem.month3Sales >= month3QualLvl && segmentSalesToApply == 3) ? month3Amount : 0;
                totalEarnings = month1Earnings + month2Earnings + month3Earnings;
                let telNo = "tel:" + dem.smsQueryCell;
                rec = {
                    demStartPeriodId: dem.demStartPeriodId,
                    sfCurrentCode: dem.sfCurrentCode,
                    smsQueryCell: [<a href={telNo}>{dem.smsQueryCell}</a>],
                    firstNames: dem.firstNames,
                    surname: dem.surname,
                    //month1Sales: segmentSalesToApply == 1 ? [<span style={{ fontWeight: "bold" }}>{this.formatter.formatCurrency(dem.month1Sales)}</span>] : this.formatter.formatCurrency(dem.month1Sales),
                    //earnMonth1: (dem.month1Sales >= month1QualLvl && segmentSalesToApply == 1) ? [<MDBIcon className="green-text" far icon="check-circle" />] : segmentSalesToApply == 1 ? [<MDBIcon className="red-text" far icon="times-circle" />] : '',
                    month2Sales: segmentSalesToApply == 2 ? [<span style={{ fontWeight: "bold" }}>{this.formatter.formatCurrency(dem.month2Sales)}</span>] : this.formatter.formatCurrency(dem.month2Sales),
                    earnMonth2: (dem.month2Sales >= month2QualLvl && segmentSalesToApply == 2) ? [<MDBIcon className="green-text" far icon="check-circle" />] : segmentSalesToApply == 2 ? [<MDBIcon className="red-text" far icon="times-circle" />] : '',
                    month3Sales: segmentSalesToApply == 3 ? [<span style={{ fontWeight: "bold" }}>{this.formatter.formatCurrency(dem.month3Sales)}</span>] : this.formatter.formatCurrency(dem.month3Sales),
                    earnMonth3: (dem.month3Sales >= month3QualLvl && segmentSalesToApply == 3) ? [<MDBIcon className="green-text" far icon="check-circle" />] : segmentSalesToApply == 3 ? [<MDBIcon className="red-text" far icon="times-circle" />] : '',
                }
                demRecs.push(rec);
            }
        });
        let tableData = {
            columns: [{
                label: 'Start Segment',
                field: 'demStartPeriodId',
                sort: 'asc'
            },
            {
                label: 'Dem Code',
                field: 'sfCurrentCode',
                sort: 'asc'
            },
            {
                label: 'Cell No',
                field: 'smsQueryCell',
                sort: 'asc'
            },
            {
                label: 'First Names',
                field: 'firstNames',
                sort: 'asc'
            },
            {
                label: 'Surname',
                field: 'surname',
                sort: 'asc'
            },
            //{
            //    label: 'Month 1 Sales',
            //    field: 'month1Sales',
            //    sort: 'asc'
            //},
            //{
            //    label: 'Earn Month 1',
            //    field: 'earnMonth1',
            //    sort: 'asc'
            //},
            {
                label: 'Month 2 Sales',
                field: 'month2Sales',
                sort: 'asc'
            },
            {
                label: 'Earn Month 2',
                field: 'earnMonth2',
                sort: 'asc'
            },
            {
                label: 'Month 3 Sales',
                field: 'month3Sales',
                sort: 'asc'
            }, {
                label: 'Earn Month 3',
                field: 'earnMonth3',
                sort: 'asc'
            }],
            rows: demRecs
        }
        this.setState({
            teamData: tableData,
            tableHidden: false,
            m1Earnings: month1Earnings,
            m2Earnings: month2Earnings,
            m3Earnings: month3Earnings,
            totalGetUpEarnings: totalEarnings,
            unitStandard: personalLevels.data.poLevel,
            personalSalesStandard: personalLevels.data.getUpPersonalSalesLvl,
            unitSales: personalLevels.data.unitSalesIncPOSales,
            personalSales: personalLevels.data.personalSales
        });
        this.props.loaderOff();


    }

    render() {
        let TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        let statusType = TMAUser.data.statusCode1;
        let msg = 'These earnings have not been unlocked yet.'
        if (this.state.personalSales >= this.state.personalSalesStandard && this.state.unitSales >= this.state.unitStandard) {
            msg = 'Congratulations, these earnings have been unlocked.'
        }
        return (
            <div>
                <Header headerText='Get Up'
                    subHeaderText="(Click Go to load Get Up report from selected segment looking back.)"
                    hideSearch='true'
                />
                <MDBCard>
                    <MDBCardBody>
                        <MDBRow>
                            <MDBCol md="6">
                                <MDBContainer>
                                    <MDBRow className="mt-3">
                                        <MDBCol>
                                            <MDBSelect label="Year..."
                                                options={this.state.yearData}
                                                selected="Filter"
                                                getValue={this.handleYearSelectChange}
                                                required
                                            />
                                        </MDBCol>

                                    </MDBRow>
                                    <MDBRow className="mt-3">
                                        <MDBCol>
                                            <MDBSelect label="Segment..."
                                                options={this.state.segmentData}
                                                selected="Filter"
                                                getValue={this.handleSegmentSelectChange}
                                                required
                                            />
                                        </MDBCol>
                                    </MDBRow>
                                    {statusType == "T" ? <MDBRow className="mt-3">
                                        <MDBCol>
                                            <MDBSelect label="Unit..."
                                                options={this.state.unitData}
                                                selected="Filter"
                                                getValue={this.handleUnitSelectChange}
                                                required
                                            />
                                        </MDBCol>
                                    </MDBRow> : <div></div>}

                                    <MDBRow>
                                        <MDBCol>
                                            <MDBBtn onClick={this.getGetUpData}>Go</MDBBtn>
                                        </MDBCol>
                                    </MDBRow>
                                </MDBContainer>
                            </MDBCol>

                            <MDBCol md="6">
                                <MDBContainer>
                                    <MDBRow>
                                        <h5>All Managers and Team Leaders</h5>
                                    </MDBRow>
                                    <MDBRow>Recruit, train, qualify and retain your your new unit recruits over 3 months. Earn extra money and build your unit sales.</MDBRow>
                                    <br />
                                    <MDBRow>
                                        <ul>
                                            {/*<li>Month 1: earn <span style={{ fontWeight: "bold" }}>{this.state.earnM1}</span> per qualified unit recruit</li>*/}
                                            <li>Month 2: earn <span style={{ fontWeight: "bold" }}>{this.state.earnM2}</span> per qualified unit recruit</li>
                                            <li>Month 3: earn <span style={{ fontWeight: "bold" }}>{this.state.earnM3}</span> per qualified unit recruit</li>
                                        </ul>
                                    </MDBRow>
                                </MDBContainer>
                            </MDBCol>
                        </MDBRow>

                        <br />

                        <div hidden={this.state.tableHidden}>
                            <hr />
                            <MDBRow>
                                <MDBCol md="6">
                                    <MDBContainer>
                                        <MDBRow>
                                            <span style={{ fontWeight: "bold" }}>Get Up</span>&nbsp;Analysis for recruits recruited in the Three Months
                                        </MDBRow>
                                        <MDBRow>
                                            looking back from {this.state.selectedSegment}
                                        </MDBRow>
                                    </MDBContainer>
                                    <br />
                                    <MDBContainer>
                                        <MDBRow>
                                            <span style={{ fontWeight: "bold" }}>NB</span>&nbsp;To unlock these earnings {statusType == 'T' ? 'selected unit/manager' : 'you'} must achieve:
                                        </MDBRow>
                                        <MDBRow>
                                            Personal Sales: &nbsp;<span style={{ fontWeight: "bold" }}>{this.formatter.formatCurrency(this.state.personalSalesStandard)}</span>&nbsp;- Progress: &nbsp; <span style={{ fontWeight: "bold" }}>{this.formatter.formatCurrency(this.state.personalSales)}</span>
                                        </MDBRow>
                                        <MDBRow>
                                            Unit Sales: &nbsp;<span style={{ fontWeight: "bold" }}>{this.formatter.formatCurrency(this.state.unitStandard)}</span>&nbsp;- Progress: &nbsp; <span style={{ fontWeight: "bold" }}>{this.formatter.formatCurrency(this.state.unitSales)}</span>
                                        </MDBRow>
                                        
                                    </MDBContainer>
                                </MDBCol>
                                <br />
                                <MDBCol md="6">
                                    <MDBContainer>
                                        
                                        
                                        <MDBRow>Get Up Earnings Split For {this.state.selectedSegment}</MDBRow>
                                        <MDBRow>
                                            <ul>
                                                {/*<li>Month 1 Earnings:&nbsp; <span style={{ fontWeight: "bold" }}>{this.formatter.formatCurrency(this.state.m1Earnings)}</span></li>*/}
                                                <li>Month 2 Earnings:&nbsp; <span style={{ fontWeight: "bold" }}>{this.formatter.formatCurrency(this.state.m2Earnings)}</span></li>
                                                <li>Month 3 Earnings:&nbsp; <span style={{ fontWeight: "bold" }}>{this.formatter.formatCurrency(this.state.m3Earnings)}</span></li>
                                            </ul>
                                        </MDBRow>
                                        {msg == '' ? <div></div> : <MDBRow>
                                            {msg}<br />
                                        </MDBRow>
                                        }
                                        <MDBRow>Total Earnings:&nbsp; <span style={{ fontWeight: "bold" }}>{this.formatter.formatCurrency(this.state.totalGetUpEarnings)}</span></MDBRow>
                                    </MDBContainer>
                                </MDBCol>
                            </MDBRow>
                            <MDBDataTable
                                responsive
                                striped
                                bordered
                                hover
                                data={this.state.teamData}
                                paging={false}
                                autoWidth
                            />

                        </div>
                    </MDBCardBody>
                </MDBCard>
            </div>
        );
    }


}
